export const WIZARD_URL = "/kredytomat/wizard/:seed/:grain?";

export const ANSWER_TYPE = {
  grain: "grain",
  end: "end",
};
